import { useState, useEffect } from "react";
import { Box, Button, CloseButton, Dialog, HStack, Portal, Text, Textarea, VStack } from "@chakra-ui/react";
import LeadStatusBadge from "../LeadStatusBadge";

const LEAD_STATUSES = [
    "New", "ContactAttempted", "Contacted", "Conversation", "Qualifying", "Qualified",
    "Interested", "ConversionProposed", "Converted", "NotInterested", "NoResponse",
    "Disqualified", "HandedToHuman",
];

const ChangeLeadStatusModal = ({ isOpen, onClose, currentStatus, onSubmit, isLoading }) => {
    const [selectedStatus, setSelectedStatus] = useState(currentStatus);
    const [note, setNote] = useState("");

    useEffect(() => {
        if (isOpen) {
            setSelectedStatus(currentStatus);
            setNote("");
        }
    }, [isOpen, currentStatus]);

    return (
        <Dialog.Root open={isOpen} onOpenChange={(e) => { if (!e.open) onClose(); }}>
            <Portal>
                <Dialog.Backdrop />
                <Dialog.Positioner p={4}>
                    <Dialog.Content
                        bg="bg.card" color="white" borderColor="border.primary" border="1px solid"
                        w={{ base: "calc(100vw - 2rem)", md: "lg" }} maxW="100%" maxH="calc(100dvh - 2rem)"
                        overflowY="auto" borderRadius={12}
                    >
                        <Dialog.Body pt={6} pb={6} px={6}>
                            <Text fontWeight={700} fontSize="lg" mb={4}>Zmień status leada</Text>
                            <VStack align="stretch" gap={2} mb={4}>
                                {LEAD_STATUSES.map(s => (
                                    <Box
                                        key={s} as="button" onClick={() => setSelectedStatus(s)}
                                        display="flex" alignItems="center" gap={3} px={3} py={2} borderRadius={8}
                                        border="1px solid" borderColor={selectedStatus === s ? "brand.400" : "border.primary"}
                                        bg={selectedStatus === s ? "rgba(26,165,255,0.08)" : "bg.secondary"}
                                        cursor="pointer" transition="all 0.15s" _hover={{ borderColor: "brand.400" }}
                                        outline="none" textAlign="left"
                                    >
                                        <LeadStatusBadge status={s} />
                                    </Box>
                                ))}
                            </VStack>
                            <Text fontSize="sm" color="text.grey" mb={2}>Notatka (opcjonalnie)</Text>
                            <Textarea
                                placeholder="Powód zmiany statusu..."
                                value={note}
                                onChange={(e) => setNote(e.target.value)}
                                rows={3}
                                bg="bg.secondary" border="1px solid" borderColor="border.primary" color="white"
                                _placeholder={{ color: "text.grey" }} resize="vertical" mb={4}
                            />
                            <HStack justify="flex-end" gap={2}>
                                <Button variant="ghost" size="sm" onClick={onClose} disabled={isLoading}>Anuluj</Button>
                                <Button
                                    variant="primary" size="sm" loading={isLoading} disabled={!selectedStatus}
                                    onClick={() => onSubmit(selectedStatus, note.trim() || null)}
                                >
                                    Zapisz
                                </Button>
                            </HStack>
                        </Dialog.Body>
                        <Dialog.CloseTrigger asChild>
                            <CloseButton size="sm" position="absolute" top="2" right="2" color="text.grey" />
                        </Dialog.CloseTrigger>
                    </Dialog.Content>
                </Dialog.Positioner>
            </Portal>
        </Dialog.Root>
    );
};

export default ChangeLeadStatusModal;
